import { getStaticVirtualAccount } from '@api/virtual-accounts';
import { useUserContext } from '@basqet-dashboard/common/context';
import { useQuery } from 'react-query';

const getMerchantCacheKey = (user) =>
  user?.merchantId || user?.merchant_id || user?.merchant?.id || user?.id || 'current';

const useFetchStaticVirtualAccount = ({ enabled = true } = {}) => {
  const { user } = useUserContext();
  const merchantCacheKey = getMerchantCacheKey(user);

  const { isLoading, isError, data, error, refetch } = useQuery(
    ['staticVirtualAccount', merchantCacheKey, 'NGN'],
    () => getStaticVirtualAccount('NGN'),
    {
      enabled,
      retry: (failureCount, err) => {
        if (err?.response?.status === 404) return false;
        return failureCount < 2;
      },
      refetchOnMount: 'always'
    }
  );

  const notFound = isError && error?.response?.status === 404;
  const isRealError = isError && error?.response?.status !== 404;
  const account = isError ? null : data?.data || null;

  return { account, isLoading, isError: isRealError, notFound, refetch };
};

export { useFetchStaticVirtualAccount };
